// import { bettermakerEQ542 } from "../data/products/bettermakerEQ542";
import { sixpack } from "../data/products/radial/radialSixpack";
// import { radialWorkhorse } from "../data/products/radial/radialWorkhorse";
// import { radialWorkhorseWMixer } from "../data/products/radial/radialWorkhorseWMixer";
// import { waTB12 } from "../data/products/warmAudio/WATB12-500";
// import { wa12MKII } from "../data/products/warmAudio/WA12MIKII-500";
// import { cranborne500R8 } from "../data/products/cranborne500R8";
// import { shadowhillsDualVandergraph } from "../data/products/shadowhillsDualVandergraph";
import { ssl500sixchannel } from "../data/products/ssl/ssl500sixchannel";
import { sslGComp } from "../data/products/ssl/sslGComp";
import { germ500MKII } from "../data/products/chandlerLimited/germ500MKII";
import { TG2500 } from "../data/products/chandlerLimited/TG2500";
// import { Atlas } from "../data/products/prismSound/Atlas";
// import { Lyra2 } from "../data/products/prismSound/Lyra2";
// import { catapult } from "../data/products/radial/catapult";
// import { catapultMiniRX } from "../data/products/radial/catapultMiniRX";
import { rhea } from "../data/products/wesaudio/rhea";
import { dione } from "../data/products/wesaudio/dione";
import { prometheus } from "../data/products/wesaudio/prometheus";
import { hyperion } from "../data/products/wesaudio/hyperion";
import { calypso } from "../data/products/wesaudio/calypso";
import { mimas } from "../data/products/wesaudio/mimas";
import { titan } from "../data/products/wesaudio/titan";
import { phoebe } from "../data/products/wesaudio/phoebe";
import { ngbuscomp } from "../data/products/wesaudio/ngbuscomp";
import { ngleveler } from "../data/products/wesaudio/ngleveler";
import { dioneStarlight } from "../data/products/wesaudio/dioneStarlight";
import { beta76 } from "../data/products/wesaudio/beta76";
import { timbre } from "../data/products/wesaudio/timbre";
import { supercarrierII } from "../data/products/wesaudio/supercarrierII";
import { odd } from "../data/products/purpleAudio/5E1Odd";
import { action } from "../data/products/purpleAudio/5C1Action";
import { tav } from "../data/products/purpleAudio/5E2Tav";
import { lilpeqrM } from "../data/products/purpleAudio/5E3LilpeqrM";
import { mc77 } from "../data/products/purpleAudio/mc77";
import { biz } from "../data/products/purpleAudio/5M1Biz";
import { pants } from "../data/products/purpleAudio/5M2Pants";
import { cansII } from "../data/products/purpleAudio/5H1CansII";
import { moiyn } from "../data/products/purpleAudio/5S1Moiyn";
import { sweetTenRack } from "../data/products/purpleAudio/sweetTen";
import { ng76 } from "../data/products/wesaudio/ng76";
import { ng76StereoPair } from "../data/products/wesaudio/ng76Stereo";
import { mixingBundle } from "../data/products/wesaudio/mixingBundle";
import { recordingMixingBundle } from "../data/products/wesaudio/recordingMixingBundle";
import { distressorel8x } from "../data/products/empiricalLabs/distressorel8x";
import { distressorel8xPair } from "../data/products/empiricalLabs/distressorel8xPair";
import { distressorel8 } from "../data/products/empiricalLabs/distressorel8";
import { distressorel8Pair } from "../data/products/empiricalLabs/distressorel8Pair";
import { bigFreq } from "../data/products/empiricalLabs/freEQ";
import { arousor } from "../data/products/empiricalLabs/arousor";
import { mikeE } from "../data/products/empiricalLabs/el9MikeE";
import { el9MikeETwinPak } from "../data/products/empiricalLabs/el9MikeETwinPak";
import { discontinued_lilFrEQ } from "../data/products/empiricalLabs/discontinued_elqLilFrEq";
import { trakPak } from "../data/products/empiricalLabs/trakPak";
import { elx7Fatso } from "../data/products/empiricalLabs/elx7Fatso";
import { derrEsserH } from "../data/products/empiricalLabs/derrEsserH";
import { derrEsser } from "../data/products/empiricalLabs/derrEsser";
import { docDerr } from "../data/products/empiricalLabs/docDerr";
import { docDerrH } from "../data/products/empiricalLabs/docDerrH";
import { creme } from "../data/products/tegeler/creme";
import { eqp1 } from "../data/products/tegeler/eqp1";
import { cremeRC } from "../data/products/tegeler/cremeRC";
import { magnetismus2 } from "../data/products/tegeler/magnetismus2";
import { raumzeitmaschine } from "../data/products/tegeler/raumzeitmaschine";
import { schwerkraftmaschine } from "../data/products/tegeler/schwerkraftmaschine";
import { tubesummingmixer } from "../data/products/tegeler/tubesummingmixer";
import { varitubecompressor } from "../data/products/tegeler/varitubecompressor";
import { varituberecordingchannel } from "../data/products/tegeler/varituberecordingchannel";
import { vocalleveler500 } from "../data/products/tegeler/vocalleveler500";
import { mytheq500 } from "../data/products/tegeler/mytheq500";
import { hyperionEclipse } from "../data/products/wesaudio/hyperionEclipse";
import { prometheusEclipse } from "../data/products/wesaudio/prometheusEclipse";
import { vivid } from "../data/products/mother/vivid";
import { wai2950 } from "../data/products/mother/wai2950";
import { kamaya } from "../data/products/mother/kamaya";
import { pump } from "../data/products/empiricalLabs/pump";
import { mythvca500 } from "../data/products/tegeler/mythvca500";
import { ngTubeEq } from "../data/products/wesaudio/ngTubeEQ";
import { ngTubeComp } from "../data/products/wesaudio/ngTubeComp";
import { pandora } from "../data/products/wesaudio/pandora";
import { mf25SummingMixer } from "../data/products/purpleAudio/MFTwenty5SummingMixer";
import { mfSeriesFaderPack } from "../data/products/purpleAudio/MFTwentyFader";
import { mfSeriesMeter } from "../data/products/purpleAudio/MFTwentyMeterBridge";
import { stereoComp33609 } from "../data/products/neve/33609";
import { mimasGemini } from "../data/products/wesaudio/mimasGemini";
import { bax2020Beast } from "../data/products/popeAudio/BAX2020Beast";
import { bax2020Classic } from "../data/products/popeAudio/BAX2020Classic";
import { preBX } from "../data/products/popeAudio/preBX";
import { bax2020r } from "../data/products/popeAudio/BAX2020r";
import { dirtyC500 } from "../data/products/popeAudio/dirtyC500";
import { dirtyC } from "../data/products/popeAudio/dirtyC";
import { vdi } from "../data/products/hazelriggIndustries/vdi";
import { fourDI } from "../data/products/hazelriggIndustries/4di";
import { vec } from "../data/products/hazelriggIndustries/vec";
import { vlc } from "../data/products/hazelriggIndustries/vlc";
import { vne } from "../data/products/hazelriggIndustries/vne";
import { dne500 } from "../data/products/hazelriggIndustries/dne500";
import { dlc500 } from "../data/products/hazelriggIndustries/dlc500";
import { dva500 } from "../data/products/hazelriggIndustries/dva500";
import { type19 } from "../data/products/heisermanAudio/type19";
import { h251 } from "../data/products/heisermanAudio/h251";
import { h47Tube } from "../data/products/heisermanAudio/h47Tube";
import { h47Fet } from "../data/products/heisermanAudio/h47Fet";
import { neve2254R } from "../data/products/neve/2254R";
import { neve4081 } from "../data/products/neve/4081";
import { neve1073dpa } from "../data/products/neve/1073dpa";
import { neve8801 } from "../data/products/neve/8801";
import { neve1073opxDante } from "../data/products/neve/1073opxDante";
import { neveRMX16 } from "../data/products/neve/rnx16";
import { neve1073spx } from "../data/products/neve/1073spx";
import { genesysblackg32 } from "../data/products/neve/genesysblackg32";
import { ng78 } from "../data/products/wesaudio/ng78";
import { ng78StereoPair } from "../data/products/wesaudio/ng78Stereo";
import { quagPowergridDuo } from "../data/products/quagliardi/powergridDuo";
import { quagPowergrid2 } from "../data/products/quagliardi/powergrid2";
import { quagPowergrid10 } from "../data/products/quagliardi/powergrid10";
import { quagDia } from "../data/products/quagliardi/DIA";
import { quag501 } from "../data/products/quagliardi/501+";
import { quag576 } from "../data/products/quagliardi/576";
import { serpentSA76 } from "../data/products/serpentAudio/spliceSA76";
import { serpentSB4001 } from "../data/products/serpentAudio/sb4001";
import { serpentchimera } from "../data/products/serpentAudio/chimera";
import { serpentSB4001Sepia } from "../data/products/serpentAudio/sb4001Sepia";
// import { bax2020Extra } from "../data/products/popeAudio/BAX2020Extra";

export const productArray = [
  // Atlas,
  // bax2020Extra,
  // bettermakerEQ542,
  // catapult,
  // catapultMiniRX,
  // cranborne500R8, 
  // Lyra2,
  // radialWorkhorse,
  // radialWorkhorseWMixer,
  // shadowhillsDualVandergraph, 
  // wa12MKII,
  // waTB12,
  action,
  bax2020Beast,
  bax2020Classic,
  biz,
  cansII,
  derrEsser,
  dione,
  dioneStarlight,
  dirtyC500,
  dne500,
  dlc500,
  dva500,
  docDerr,
  germ500MKII,
  hyperion,
  hyperionEclipse,
  kamaya,
  lilpeqrM,
  mimas,
  mimasGemini,
  quag501,
  quag576,
  moiyn,
  mytheq500,
  mythvca500,
  odd,
  pandora,
  pants,
  phoebe,
  preBX,
  prometheus,
  prometheusEclipse,
  pump,
  rhea,
  tav,
  vivid,
  vocalleveler500,
  wai2950,
  derrEsserH,
  docDerrH,
  TG2500,
  ssl500sixchannel,
  sslGComp,
  calypso,
  neveRMX16,
  serpentSA76,
  serpentSB4001,
  serpentchimera,
  serpentSB4001Sepia,
  
  // Chassis
  mixingBundle,
  recordingMixingBundle,
  supercarrierII,
  sweetTenRack,
  titan,
  sixpack,
  quagPowergridDuo,
  quagPowergrid2,
  quagPowergrid10,

  // Microphones
  type19,
  h251,
  h47Tube,
  h47Fet,

  // Rack mounted
  bax2020r,
  creme,
  cremeRC,
  dirtyC,
  distressorel8,
  distressorel8x,
  el9MikeETwinPak,
  elx7Fatso,
  eqp1,
  discontinued_lilFrEQ,
  magnetismus2,
  mc77,
  mikeE,
  ng76,
  ng78,
  ngbuscomp,
  ngTubeComp,
  ngTubeEq,
  raumzeitmaschine,
  schwerkraftmaschine,
  stereoComp33609,
  neve1073opxDante,
  neve2254R,
  neve4081,
  neve8801,
  neve1073spx,
  neve1073dpa,
  trakPak,
  vlc,
  vne,
  vec,
  varitubecompressor,
  varituberecordingchannel,
  distressorel8Pair,
  distressorel8xPair,
  ng76StereoPair,
  ng78StereoPair,
  ngleveler,
  beta76,
  timbre,
  
  // Summing mixers
  tubesummingmixer,
  mf25SummingMixer,
  mfSeriesFaderPack,
  mfSeriesMeter,

  // mixers
  genesysblackg32,

  // DIs
  vdi,
  fourDI,
  quagDia,

  // vsts
  arousor,
  bigFreq,
];

export const numOfProducts = productArray.length;